module.exports = __webpack_public_path__ + "media/images/sp/brands/common/logo_tvb-1f374bc303c49b3b05c33ee525fa5e77.svg";